<template>
    <div>
        <v-container max-width="1500" style="max-width: 1500px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Histórico Paciente
                    <div>
                        <v-tooltip bottom color="warring">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="#e7b005" v-bind="attrs" v-on="on" dark @click="printPage"
                                    style="margin: 1rem ;height: 1.9rem;">
                                    <v-icon color="white" style="font-size: 1.5rem;color: white !important;">mdi
                                        mdi-printer-check</v-icon>
                                </v-btn>
                            </template>
                            <span>Imprimir</span>
                        </v-tooltip>
                        <v-tooltip bottom color="success">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="green" v-bind="attrs" v-on="on" dark @click="exportExcel"
                                    style="margin: 1rem 0;height: 1.9rem;">
                                    <v-icon color="white" style="font-size: 1.5rem;">mdi-download-box</v-icon>
                                </v-btn>
                            </template>
                            <span>Descargar</span>
                        </v-tooltip>
                    </div>
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-row style="padding: 1.6rem .7rem .4rem .7rem;">
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete max-width="200" class="mx-3" v-model="pacienteSelect" label="Paciente"
                            append-icon="mdi-magnify" :items="dataExplotaSearch" item-text="paciente"
                            item-value="autogenerado" outlined dense></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete max-width="200" class="mx-3" v-model="pacienteSelect" label="DNI"
                            append-icon="mdi-magnify" :items="dataExplotaSearch" item-text="dni_paciente"
                            item-value="autogenerado" outlined dense></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete max-width="200" class="mx-3" v-model="pacienteSelect" label="Autogenerado"
                            append-icon="mdi-magnify" :items="dataExplotaSearch" item-text="autogenerado"
                            item-value="autogenerado" outlined dense></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-dialog ref="dialogInicio" v-model="modalFechaInicio" :return-value.sync="dateInicio"
                            persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="dateInicio" label="Periodo inicial" append-icon="mdi-calendar"
                                    outlined dense readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateInicio" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modalFechaInicio = false">
                                    Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="saveDate">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-dialog ref="dialogFin" v-model="modalFechaFin" :return-value.sync="dateFin" persistent
                            width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="dateFin" label="Periodo final" append-icon="mdi-calendar"
                                    outlined dense readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateFin" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modalFechaFin = false">
                                    Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="saveDate2">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="1" sm="1" md="1"
                        style="padding: 0 1.5rem 0 0 !important;display:flex;justify-content: end;">
                        <v-tooltip bottom color="info">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" dark class="mb-2"
                                    style="margin: .9rem 0 .7rem .9rem;background: #1780cd;" @click="search">
                                    <v-icon style="font-size: 1.8rem;">
                                        mdi-card-search
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto; padding: 1.5rem;">
                <v-menu offset-y transition="scale-transition" :close-on-content-click="false">
                    <template v-slot:activator="{ on: menu, attrs }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn elevation="2" v-bind="attrs" v-on="{ ...tooltip, ...menu }"
                                    style="margin:1rem 0 2rem 0;">
                                    <v-icon class="custom-icon">
                                        mdi-format-list-bulleted-square
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Editar columnas</span>
                        </v-tooltip>
                    </template>

                    <v-list style="max-height:30rem;height: 100%;">
                        <v-list-item style="max-width:50rem;height: 100%;     background: white;">
                            <v-list-item-title>
                                <v-list>
                                    <v-list-item ripple @mousedown.prevent @click="toggle">
                                        <v-list-item-action>
                                            <v-icon :color="selectedColumns.length > 0 ? 'indigo darken-4' : ''">
                                                {{ icon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Seleccionar todo
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>

                                    <!-- Mostrar columnas con checkboxes -->
                                    <v-list-item v-for="header in headers" :key="header.value"
                                        @click="toggleColumn(header.value)">
                                        <v-list-item-action>
                                            <v-checkbox v-model="selectedColumns" :value="header.value"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ header.text }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <div>
                    <v-data-table ref="table" dense :headers="filteredHeaders" :items="filteredData" class="table-style"
                        :loading="isLoading" loading-text="Cargando... Por favor espere">
                        <template v-slot:[`item.paciente`]="{ item }">
                            <div @mouseover="showPopup($event, item)" @mouseleave="hidePopup"
                                style="position: relative;">
                                {{ item.paciente }}
                            </div>
                        </template>
                        <template v-slot:[`item.dosis_epo`]="{ item }">
                            <v-text-field v-model="item.dosis_epo" @input="onInputChange(item)" hide-details dense
                                style="text-align: center;" :disabled="statusEdit"></v-text-field>
                        </template>
                        <template v-slot:[`item.via`]="{ item }">
                            <v-select v-model="item.via" @change="onInputChange(item)" hide-details dense
                                style="text-align: center !important;" :items="['SC', 'IV']"
                                :disabled="statusEdit"></v-select>
                        </template>
                        <template v-slot:[`item.dosis_hierro`]="{ item }">
                            <v-text-field v-model="item.dosis_hierro" @input="onInputChange(item)" hide-details dense
                                style="text-align: center; " :disabled="statusEdit"></v-text-field>
                        </template>
                        <template v-slot:[`item.observaciones`]="{ item }">
                            <v-text-field v-model="item.observaciones" @input="onInputChange(item)" hide-details dense
                                style="text-align: center;" :disabled="statusEdit"></v-text-field>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<style scoped>
.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

.add-column {
    position: absolute;
    left: -10%;
    height: 1.2rem;
    width: 1.2rem;
    bottom: -85%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

.minus-column {
    position: absolute;
    left: -10%;
    height: 1.2rem;
    width: 1.2rem;
    bottom: -85%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

::v-deep .table-style table tr:hover .add-column {
    display: flex !important;
    cursor: pointer;
}

::v-deep .table-style table tr:hover .minus-column {
    display: flex !important;
    cursor: pointer;
}

.popup-window {
    width: 20rem;
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

::v-deep .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    text-align: center !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep .v-btn {
    text-transform: capitalize !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
    color: white;
    font-size: 600;
}

.custom-btn {
    width: 32px !important;
    height: 32px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    /* background: rgb(27 160 255 / 12%); */
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}

::v-deep .highlight-column {
    background-color: #f0f0f0 !important;
    /* Color de fondo para las columnas visibles */
    transition: background-color 0.3s ease;
    /* Añade una transición suave */
}

@media print {
    .no-print {
        display: none;
    }
}
</style>
<script>
import { text } from "@fortawesome/fontawesome-svg-core";
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
    data() {
        return {
            dialogLoader: false,
            pacienteSelect: null,
            dialogForm: false,
            statusEdit: true,
            statusViewColumnHB: false,
            popupVisible: false,
            hoveredItem: null,
            popupStyles: {
                top: '-8000px',
                left: '0px'
            },
            dialogHistograma: false,
            date: new Date().toISOString().slice(0, 7),
            dateInicio: new Date().toISOString().slice(0, 10),
            dateFin: new Date().toISOString().slice(0, 10),
            dateHoy: new Date().toISOString().slice(0, 10),
            modal: false,
            modalFechaFin: false,
            modalFechaInicio: false,
            searchSubactividad: null,
            searchDNI: [],
            dataPaciente: [],
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "FECHA RESULTADO", value: "FECHA_RESULTADO", align: "center" },
                { text: "NUM DOC", value: "NUM_DOC", align: "center" },
                { text: "PACIENTE", value: "PACIENTE", align: "center" },
                { text: "AUTOGENERADO", value: "AUTOGENERADO", align: "center" },
                { text: "CLÍNICA", value: "IPRESS", align: "center" },
                { text: "ALBUMINA", value: "ALBUMINA", align: "center" },
                { text: "CALCIO TOTAL", value: "CALCIO_TOTAL", align: "center" },
                { text: "CALCIO POST", value: "CALCIO_POST", align: "center" },
                { text: "CALCIO PRE", value: "CALCIO_PRE", align: "center" },
                { text: "CALCIO IONIZADO", value: "CALCIO_IONIZADO", align: "center" },
                { text: "CLORURO", value: "CLORURO", align: "center" },
                { text: "COLESTEROL", value: "COLESTEROL", align: "center" },
                { text: "CREATININA", value: "CREATININA", align: "center" },
                { text: "CREATININA POST", value: "CREATININA_POST", align: "center" },
                { text: "CREATININA PRE", value: "CREATININA_PRE", align: "center" },
                { text: "FERRITINA", value: "FERRITINA", align: "center" },
                { text: "GLUCOSA", value: "GLUCOSA", align: "center" },
                { text: "FIERRO", value: "FIERRO", align: "center" },
                { text: "COLESTEROL HDL", value: "COLESTEROL_HDL", align: "center" },
                { text: "COLESTEROL LDL", value: "COLESTEROL_LDL", align: "center" },
                { text: "PARATOHORMONA", value: "PARATOHORMONA", align: "center" },
                { text: "FOSFATASA ALCALINA", value: "FOSFATASA_ALCALINA", align: "center" },
                { text: "FOSFORO", value: "FOSFORO", align: "center" },
                { text: "FOSFORO POST", value: "FOSFORO_POST", align: "center" },
                { text: "FOSFORO PRE", value: "FOSFORO_PRE", align: "center" },
                { text: "POTASIO", value: "POTASIO", align: "center" },
                { text: "SODIO", value: "SODIO", align: "center" },
                { text: "TRANSAMINASA GLUTAMICO PIRUVIC", value: "TRANSAMINASA_GLUTAMICO_PIRUVIC", align: "center" },
                { text: "TRANSAMINASA GLUTAMICO OXALACE", value: "TRANSAMINASA_GLUTAMICO_OXALACE", align: "center" },
                { text: "TRANSFERRINA", value: "TRANSFERRINA", align: "center" },
                { text: "UREA", value: "UREA", align: "center" },
                { text: "ACIDO URICO", value: "ACIDO_URICO", align: "center" },
                { text: "GLOBULOS BLANCOS", value: "GLOBULOS_BLANCOS", align: "center" },
                { text: "GLOBULOS ROJOS", value: "GLOBULOS_ROJOS", align: "center" },
                { text: "HEMATOCRITO", value: "HEMATOCRITO", align: "center" },
                { text: "HEMOGLOBINA", value: "HEMOGLOBINA", align: "center" },
                { text: "PROTEINA C REACTIVA", value: "PROTEINA_C_REACTIVA", align: "center" },
                { text: "ANTIGENO HEPATIT", value: "ANTIGENO_HEPATIT", align: "center" },
                { text: "ANTICUERPO DE HEPATITIS B CORE", value: "ANTICUERPO_HEPATITIS_CORE", align: "center" },
                { text: "ANTICUERPO HEPATITIS C", value: "ANTICUERPO_HEPATITIS_C", align: "center" },
                { value: "UREA_POST", align: "center", text: "UREA POST", sortable: false },
                { value: "UREA_PRE", align: "center", text: "UREA PRE", sortable: false },
                { value: "PARATOHORMONA_INTACTA", align: "center", text: "PARATOHORMONA INTACTA", sortable: false },
                { value: "PROTEINAS_TOTALES", align: "center", text: "PROTEINAS TOTALES", sortable: false },
                { value: "VDRL_SEROLOGICAS", align: "center", text: "VDRL (SEROLOGICAS)", sortable: false },
                { value: "TRIGLICERIDOS", align: "center", text: "TRIGLICERIDOS", sortable: false },
                { value: "HCO3", align: "center", text: "HCO3", sortable: false },
                { value: "ANTICUERPO_HEPATITIS_B", align: "center", text: "ANTICUERPO HEPATITIS B", sortable: false },
                { value: "ANTIGENO_SUPERFICIE_HEPAT", align: "center", text: "AnTi HBs", sortable: false },
                { value: "ANTICUERPO_EPSILON", align: "center", text: "ANTICUERPO DE EPSILON PARA HEP", sortable: false },
                { value: "ANTICUERPO_HEPATITIS_VIRUS_C", align: "center", text: "ANTICUERPO HEPATITIS VIRUS C", sortable: false },
                { value: "ANTICUERPO_HIV", align: "center", text: "ANTICUERPO HIV", sortable: false },
                { value: "TGO", align: "center", text: "TGO", sortable: false },
                { value: "ACIDO_FOLICO", align: "center", text: "ACIDO FOLICO", sortable: false },
                { value: "VITAMINA_B12", align: "center", text: "VITAMINA B12", sortable: false },
                { value: "ABASTONADOS", align: "center", text: "ABASTONADOS", sortable: false },
                { value: "BASOFILOS", align: "center", text: "BASOFILOS", sortable: false },
                { value: "EOSINOFILOS", align: "center", text: "EOSINOFILOS", sortable: false },
                { value: "LINFOCITOS", align: "center", text: "LINFOCITOS", sortable: false },
                { value: "MONOCITOS", align: "center", text: "MONOCITOS", sortable: false },
                { value: "SEGMENTADOS", align: "center", text: "SEGMENTADOS", sortable: false },
                { value: "CONC_HB_CORPUSCULAR_MEDIA", align: "center", text: "CONC HB CORPUSCULAR MEDIA", sortable: false },
                { value: "HB_CORPUSCULAR_MEDIA", align: "center", text: "HB CORPUSCULAR MEDIA ", sortable: false },
                { value: "NRBC", align: "center", text: "NRBC", sortable: false },
                { value: "RDW_CV", align: "center", text: "RDW CV", sortable: false },
                { value: "RDW_SD", align: "center", text: "RDW SD", sortable: false },
                { value: "VOLUMEN_CORSPUCULAR_MEDIO", align: "center", text: "VOLUMEN CORSPUCULAR MEDIO", sortable: false },
                { value: "PCT", align: "center", text: "PCT", sortable: false },
                { value: "RECUENTO_PLAQUETAS", align: "center", text: "RECUENTO PLAQUETAS", sortable: false },
                { value: "PDW", align: "center", text: "PDW", sortable: false },
                { value: "VOLUMEN_PLAQUETARIO_MEDIO", align: "center", text: "VOLUMEN PLAQUETARIO MEDIO", sortable: false },
                { value: "PARATHORMONA_INTACTA", align: "center", text: "PARATHORMONA INTACTA", sortable: false },
                { value: "POR_SATURACION", align: "center", text: "POR SATURACION", sortable: false },
                { value: "BETA_2", align: "center", text: "BETA 2", sortable: false },
                { value: "VITAMINA_D", align: "center", text: "VITAMINA D", sortable: false },
                { value: "TRU", align: "center", text: "TRU", sortable: false },
                { value: "KTV", align: "center", text: "KTV", sortable: false }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            itemsTipSex: ["MASCULINO", "FEMENINO"],
            menu: false,
            selectedColumns: [
                'FECHA_RESULTADO', 'NUM_DOC', 'PACIENTE', 'AUTOGENERADO', 'IPRESS',
                'ALBUMINA', 'CALCIO_TOTAL', 'CALCIO_POST', 'CALCIO_PRE', 'CALCIO_IONIZADO',
                'CLORURO', 'COLESTEROL', 'CREATININA', 'CREATININA_POST', 'CREATININA_PRE',
                'FERRITINA', 'GLUCOSA', 'FIERRO', 'COLESTEROL_HDL', 'COLESTEROL_LDL',
                'PARATOHORMONA', 'FOSFATASA_ALCALINA', 'FOSFORO', 'FOSFORO_POST',
                'FOSFORO_PRE', 'POTASIO', 'SODIO', 'TRANSAMINASA_GLUTAMICO_PIRUVIC',
                'TRANSAMINASA_GLUTAMICO_OXALACE', 'TRANSFERRINA', 'TRIGLICERIDOS', 'UREA',
                'ACIDO_URICO', 'GLOBULOS_BLANCOS', 'GLOBULOS_ROJOS', 'HEMATOCRITO',
                'HEMOGLOBINA', 'PROTEINA_C_REACTIVA', 'ANTIGENO_HEPATIT',
                'ANTICUERPO_HEPATITIS_CORE', 'ANTICUERPO_HEPATITIS_C','ANTICUERPO_HEPATITIS_VIRUS_C','UREA_PRE','UREA_POST','HCO3','ANTICUERPO_HEPATITIS_B',
                'ANTIGENO_SUPERFICIE_HEPAT','ANTICUERPO_EPSILON','ACIDO_FOLICO','VITAMINA_B12','PROTEINAS',
                'SEROLOGIA','COD_IPRESS','IPRESS','TGO','ABASTONADOS','BASOFILOS','CONC_HB_CORPUSCULAR_MEDIA',
                'EOSINOFILOS','HB_CORPUSCULAR_MEDIA','LINFOCITOS','MONOCITOS','NRCB','PCT','PDW','RDW_CV','RDW_SD',
                'RECUENTO_PLAQUETAS','SEGMENTADOS','VOLUMEN_CORPUSCULAR_MEDIO','VOLUMEN_PLAQUETARIO_MEDIO',
                'PARATHORMONA_INTACTA','KTV', 'ANTICUERPO_HIV','POR_SATURACION','BETA_2','VITAMINA_D','PARATOHORMONA_INTACTA','VDRL_SEROLOGICAS','PROTEINAS_TOTALES','VOLUMEN_CORSPUCULAR_MEDIO','NRBC',
                'TRU'
            ],
            itemMes: null,
            itemPeriodo: null,
            statusViewColumn: false,
            dataArray: [],
            dataExplota: [],
            dataExplotaSearch: [],
            pacienteDatos: []
        };
    },
    methods: {
        printPageSeleccion() {
            // Crear un nuevo contenedor div para el contenido de impresión
            const printWindow = window.open('', '', 'height=600,width=800');
            printWindow.document.write(`
                <html>
                <head>
                    <style>
                        /* Estilos para el contenido de impresión */
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                        }
                        h2 {
                            text-align: center;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-top: 20px;
                        }
                        th, td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: center;
                        }
                        td{
                            text-align: center;
                        }
                        th {
                            background-color: #f2f2f2;
                        }
                    </style>
                </head>
                <body>
                    <div>
                        <h2>RESULTADOS DE EXÁMENES DE LABORATORIO</h2>
                        <p>Nombres: <strong>${this.filteredData[0].PACIENTE}</strong></p>
                        <p>DNI: <strong>${this.filteredData[0].NUM_DOC}</strong></p>
                        <p>Autogenerado: <strong>${this.filteredData[0].AUTOGENERADO}</strong></p>
                        
                        <table>
                            <tr>
                                ${this.filteredHeaders.map(result => `
                                <th>${result.text}</th>
                                `).join('')}
                            </tr>
                            ${this.filteredData.map(result => `
                            <tr>
                                ${this.selectedColumns.map(item => `
                                <td>${result[item]}</td>
                                `).join('')}
                            </tr>
                            `).join('')}
                        </table>
                    </div>
                    <h6>Resultados sin valor oficial.</h6>
                </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.print();
        },
        printPage() {
            // Crear un nuevo contenedor div para el contenido de impresión
            const printWindow = window.open('', '', 'height=600,width=800');
            printWindow.document.write(`
            <html>
            <head>
            <style>
                /* Estilos para el contenido de impresión */
                body {
                    font-family: Arial, sans-serif;
                    margin: 20px;
                }
                h2 {
                    text-align: center;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 20px;
                }
                th, td {
                    border: 1px solid #ddd;
                    padding: 8px;
                    text-align: center;
                }
                td{
                    text-align: center;
                }
                th {
                    background-color: #f2f2f2;
                }
            </style>
            </head>
            <body>
            <div>
                <h2>RESULTADOS DE EXÁMENES DE LABORATORIO</h2>
                <p>Nombres: <strong>${this.filteredData[0].PACIENTE}</strong></p>
                <p>DNI: <strong>${this.filteredData[0].NUM_DOC}</strong></p>
                <p>Autogenerado: <strong>${this.filteredData[0].AUTOGENERADO}</strong></p>
                <table>
                    <tr>
                        <th>Fecha</th>
                        <th>IPRESS</th>
                        <th>TRU</th>
                        <th>KTV</th>
                    </tr>
                    ${this.filteredData.map(result => `
                    <tr>
                        <td>${result.FECHA_RESULTADO}</td>
                        <td>${result.IPRESS}</td>
                        <td>${result.TRU}</td>
                        <td>${result.KTV}</td>
                    </tr>
                    `).join('')}
                </table>
            </div>
            <h6>Resultados sin valor oficial.</h6>
            </body>
            </html>
            `);
            printWindow.document.close();
            printWindow.print();
        },
        toggle() {
            if (this.selectedColumns.length === this.headers.length) {
                this.selectedColumns = [
                    "FECHA_RESULTADO", "SALA", "NUM_DOC", "AUTOGENERADO", "PACIENTE"];
            } else {
                this.selectedColumns = this.headers.map(header => header.value);
            }
        },
        toggleColumn(value) {
            const index = this.selectedColumns.indexOf(value);
            if (index === -1) {
                this.selectedColumns.push(value);
            } else {
                this.selectedColumns.splice(index, 1);
            }
        },
        openForm() {
            this.dialogForm = true;
        },
        closeForm() {
            this.dialogForm = false;
        },
        search() {
            console.log("cabeceza",this.filteredHeaders);
            this.selectPaciente();
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_reporte_laboratorio_historico/", { "fecha_inicio": this.dateInicio, "fecha_fin": this.dateFin, "autogenerado": this.pacienteSelect }, {
                            headers: { Authorization: this.auth }
                        })
                        .then((res) => {
                            this.isLoading = false;
                            const meses = [
                                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                            ];

                            // Supongamos que tienes el número del mes como un string "09"
                            this.dataExplota = [];
                            this.desserts = [];
                            for (let i = 0; i < res.data.length; i++) {
                                const [dia, mes, año] = res.data[i].FECHA_RESULTADO.split('-');
                                const numeroMes = mes;
                                const indiceMes = parseInt(numeroMes, 10) - 1; // Convertir a entero y ajustar el índice (0 = Enero)

                                const nombreMes = meses[indiceMes];
                                this.dataExplota.push(
                                    Object.assign(
                                        {
                                            PERIODO: año
                                        },
                                        {
                                            MES: nombreMes,
                                        },
                                        res.data[i]
                                    )
                                );
                            }
                            //this.desserts = res.data;
                            console.log("dataIncidencias", this.desserts);

                            this.dataArray = [];
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        save() {
            this.statusEdit = true;
            console.log("se guardan los siquientes cambios", this.dataArray);
            for (let i = 0; i < this.dataArray.length; i++) {
                const element = this.dataArray[i];
                axios
                    .post(RUTA_API + "/api/token/", {
                        username: USUARIO,
                        password: PASSWORD,
                    })
                    .then((response) => {
                        this.auth = "Bearer " + response.data.access;
                        axios
                            .post(RUTA_API + "/generar_actualizar_protocolo_anemia/", { "id": element.id, "dosis_epo": element.dosis_epo, "via": element.via, "dosis_hierro": element.dosis_hierro, "observaciones": element.observaciones }, {
                                headers: { Authorization: this.auth },
                            })
                            .then((res) => {
                                this.isLoading = false;
                                this.dataInit();
                                this.dataArray = [];
                            })
                            .catch((res) => {
                                console.log("Error:", res);
                            });
                    })
                    .catch((response) => {
                        response === 404
                            ? console.warn("lo sientimos no tenemos servicios")
                            : console.warn("Error:", response);
                    });
            }
        },
        showPopup(event, item) {
            this.hoveredItem = item;
            this.dialogHistograma = true;
            // Ajustar la posición de la ventana emergente según la posición del mouse
            this.popupStyles.top = `${event.clientY - 380}px`;
            this.popupStyles.left = `${event.clientX - 400}px`;
        },
        hidePopup() {
            this.dialogHistograma = false;
            this.hoveredItem = null;
        },
        onMouseOver(valor) {
            this.dialogHistograma = true;
            console.log("valor de lo que asa el mouse por encima", valor.paciente);
        },
        closeHistograma() {
            this.dialogHistograma = false;
        },
        onInputChange(valor) {
            // Verifica si el array ya existe en `this.dataArray`
            const existe = this.dataArray.some(
                (arr) => JSON.stringify(arr.num_doc) === JSON.stringify(valor.num_doc)
            );

            // Si no existe, lo agrega
            if (!existe) {
                this.dataArray.push(valor);
            }
            console.log("valor de un item expuestossss ", valor);
            console.log("valor", this.dataArray);
        },
        updateItem(valor) {
            console.log("valor de un item expuesto ", valor);
        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodoInicio();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialogInicio.save(this.dateInicio);
        },
        saveDate2() {
            // Ejecuta la lógica adicional
            this.loadPeriodoFin();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialogFin.save(this.dateFin);
        },
        loadPeriodoInicio() {
            let [year, month] = this.dateInicio.split('-');
            this.itemMes = month;
            this.itemPeriodo = year;
            this.datosExplota();
        },
        loadPeriodoFin() {
            let [year, month] = this.dateFin.split('-');
            /*  this.itemMes = month;
             this.itemPeriodo = year;
             this.datosExplota(); */
        },
        selectPaciente() {
            let filteredData = this.dataExplotaSearch.filter(item => item.autogenerado === this.pacienteSelect);
            this.pacienteDatos = filteredData[0];

        },
        exportExcel() {
                // Importar xlsx-js-style
                const XLSXStyle = require("xlsx-js-style");

                // Definir cabecera
                const headers = this.selectedColumns.map(column => {
                    const header = this.headers.find(h => h.value === column);
                    return header ? header.text : column;
                });

                // Convertir datos a formato adecuado para la hoja de cálculo
                const datos = this.filteredData;

                // Inicializar rows con los encabezados
                const rows = [headers];

                // Añadir datos a las filas
                datos.forEach(item => {
                    const row = this.selectedColumns.map(column => item[column]);
                    rows.push(row);
                });

                // Crear una hoja de cálculo
                const worksheetData = rows;
                const worksheet = XLSXStyle.utils.aoa_to_sheet(worksheetData);
                // Define el rango para el filtro, por ejemplo, desde A1 hasta la última columna de la fila de encabezados

                const rangoFiltro = `A1:${XLSXStyle.utils.encode_col(headers.length - 1)}1`;

                // Agregar el filtro al rango definido
                worksheet['!autofilter'] = { ref: rangoFiltro };
                // Aplicar estilo a las celdas
                // Estilo para el borde de todas las celdas
                const cellStyle = {
                    alignment: { horizontal: 'center', vertical: 'center' },  // Centrar texto
                    border: {
                        top: { style: 'thin', color: { rgb: '000000' } },
                        bottom: { style: 'thin', color: { rgb: '000000' } },
                        left: { style: 'thin', color: { rgb: '000000' } },
                        right: { style: 'thin', color: { rgb: '000000' } }
                    }
                };

                // Estilo específico para la cabecera (relleno plomo, texto blanco)
                const headerStyle = {
                    fill: { fgColor: { rgb: "7A7A7A" } },
                    font: { color: { rgb: "FFFFFF" }, bold: true },
                    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },  // Centrar texto
                    border: {
                        top: { style: 'thin', color: { rgb: '000000' } },
                        bottom: { style: 'thin', color: { rgb: '000000' } },
                        left: { style: 'thin', color: { rgb: '000000' } },
                        right: { style: 'thin', color: { rgb: '000000' } }
                    }
                };


                // Aplicar estilo a todas las celdas (bordes negros)
                rows.forEach((row, rowIndex) => {
                    row.forEach((_, colIndex) => {
                        const cellRef = XLSXStyle.utils.encode_cell({ c: colIndex, r: rowIndex });
                        if (!worksheet[cellRef]) worksheet[cellRef] = {}; // Si la celda no existe, la crea
                        worksheet[cellRef].s = cellStyle; // Aplicar estilo
                    });
                });
                //Aplicar filtro a todas las cabeceras
                headers.forEach((header, index) => {
                    const cellRef = XLSXStyle.utils.encode_cell({ c: index, r: 0 });
                    worksheet[cellRef].s = headerStyle;
                });
                // Crear el libro de trabajo y añadir la hoja
                const workbook = XLSXStyle.utils.book_new();
                XLSXStyle.utils.book_append_sheet(workbook, worksheet, 'Registros laboratorio');

                // Exportar a archivo Excel
                XLSXStyle.writeFile(workbook, 'Resultados_Laboratorio.xlsx');
        },
        exportPDF() {
            const doc = new jsPDF('p', 'mm', 'a4');
            const margin = 10; // Márgen de 10mm a los lados

            // Añadir título y logos
            doc.setFontSize(16);
            doc.text('Resultados de paciente', 105, 20, { align: 'center' });

            // Agregar los logos
            doc.addImage('https://upload.wikimedia.org/wikipedia/commons/5/56/Logo_EsSalud.png', 'PNG', 10, 5, 40, 20);  // Logo izquierdo
            doc.addImage('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZPNrIDN5kEEFk0FwSGAv1Pqy3ptIyMWNCEQ&s', 'PNG', 160, 5, 40, 20);  // Logo derecho

            // Agregar información del paciente
            doc.setFontSize(10);
            doc.text(`DNI: ${this.pacienteDatos.dni_paciente}`, 15, 40);
            doc.text(`Nombres: ${this.pacienteDatos.paciente}`, 15, 45);
            doc.text(`Autogenerado: ${this.pacienteSelect}`, 110, 40);
            doc.text(`Fecha: ${this.dateHoy}`, 110, 45);

            // Extraer las cabeceras seleccionadas
            const headers = this.selectedColumns.map(column => {
                const header = this.headers.find(h => h.value === column);
                return header ? header.text : column;
            });

            // Convertir datos a formato adecuado
            const datos = this.filteredData;

            // Inicializar filas con los encabezados
            const rows = datos.map(item => {
                return this.selectedColumns.map(column => item[column]);
            });
            // Crear la tabla con autoTable
            doc.autoTable({
                startY: 55, // Asegura que la tabla comience después de la información del paciente
                margin: { left: margin, right: margin }, // Márgenes a los lados
                head: [headers], // Cabeceras de las columnas
                body: rows, // Datos de la tabla
                styles: {
                    cellPadding: 3, // Espaciado dentro de las celdas
                    fontSize: 7, // Tamaño de fuente más pequeño para ajustarse mejor
                    overflow: 'linebreak', // Ajusta el texto largo dentro de las celdas
                },
                columnStyles: {
                    // Ajuste automático del ancho de todas las columnas
                    0: { cellWidth: 'auto' },
                    1: { cellWidth: 'auto' },
                    2: { cellWidth: 'auto' },
                    3: { cellWidth: 'auto' },
                    4: { cellWidth: 'auto' },
                    // Añade más columnas según sea necesario
                },
                didDrawPage: (data) => {
                    // Añadir pie de página si lo necesitas
                    doc.setFontSize(8);
                    const pageCount = doc.internal.getNumberOfPages();
                    doc.text(`Página ${data.pageNumber} de ${pageCount}`, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 10);
                }
            });

            // Guardar el PDF
            doc.save('tabla_dinamica.pdf');
        },
        dataInit() {
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_protocolo_anemia/", { "fecha": this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            this.dataPaciente = res.data;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        datosExplota() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_pacientes_laboratorio/", { periodo: this.dateInicio.slice(0, 7) }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataExplotaSearch = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers.filter(header => this.selectedColumns.includes(header.value));
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        filteredData() {
            console.log("this.searchDNI ", this.searchDNI)
            if (!this.searchSubactividad && this.searchDNI.length == 0) {
                return this.dataExplota;
            }
            let filtered = this.dataExplota;
            if (this.searchSubactividad) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.paciente;
                    return nombreCompleto.toLowerCase().includes(this.searchSubactividad.toLowerCase());
                });
            }
            if (this.searchDNI.length !== 0) {
                filtered = filtered.filter((item) =>
                    item.AUTOGENERADO
                        .toLowerCase()
                        .includes(this.searchDNI)
                );
            }
            return filtered;
        },
        icon() {
            if (this.likesAllFruit) return 'mdi-close-box'
            if (this.likesSomeFruit) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        likesAllFruit() {
            return this.headers.length === this.selectedColumns.length
        },
        likesSomeFruit() {
            return this.headers.length > 0 && !this.likesAllFruit
        },
    },
    created() {
        this.loadPeriodoInicio();
        this.datosExplota();
    },
    components: {
        /*   Histograma,
          Form */
    },
};
</script>